import React from "react";

const Header = ({ setMostrarLogin, setUsuarioAutenticado, setTipoUsuario, usuarioAutenticado, tipoUsuario }) => {
    const manejarIniciarSesion = () => {
        setMostrarLogin(true); 
    };

    const cerrarSesion = () => {
        // Actualiza los estados y limpia el almacenamiento 
        setTipoUsuario('');
        setUsuarioAutenticado(false);
        setMostrarLogin(false); // Oculta el formulario de login
    
        localStorage.removeItem("usuarioAutenticado");
        localStorage.removeItem("tipoUsuario");
        localStorage.removeItem("user");
    };

    return (
        <header className="custom-header text-white d-flex align-items-center mt-1">
            <div className="container d-flex justify-content-between align-items-center">
                <a className="navbar-brand" href="#">
                    <img src="./logo.png" alt="Logo" width="60" height="54" />
                </a>
                <h4>{tipoUsuario === 'admin' ? "Makrosoft" : tipoUsuario === 'consulta' ? 'Consulta Emtel' : ''}</h4>
                {!usuarioAutenticado ? (
                    <button
                        className="btn btn-outline-light"
                        onClick={manejarIniciarSesion}
                    >
                        Iniciar Sesión
                    </button>
                ) : (
                    <button
                        className="btn btn-outline-light"
                        onClick={cerrarSesion}
                    >
                        Cerrar Sesión
                    </button>
                )}
            </div>
        </header>
    );
};

export default Header;
